export default __webpack_public_path__ + "static/media/school-bus-top.5343502e.png";